import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import useAuthStore from './store/authStore';

// Sayfalar
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import StudentDashboard from './pages/student/Dashboard';
import StudentProfile from './pages/student/Profile';
import StudentApplications from './pages/student/Applications';
import StudentPortfolio from './pages/student/Portfolio';
import TwoFA from './pages/student/TwoFA';
import StudentFAQ from './pages/student/FAQ';
import CompanyDashboard from './pages/company/Dashboard';
import CompanyProfile from './pages/company/Profile';
import CompanyPositions from './pages/company/Positions';
import CompanyStudents from './pages/company/Students';
import CompanyCandidates from './pages/company/Candidates';
import AdminDashboard from './pages/admin/Dashboard';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import LandingPage from './pages/LandingPage';
import VerifyEmail from './pages/VerifyEmail';
import KVKKBanner from './components/shared/KVKKBanner';
import NotFound from './pages/NotFound';
import KVKKPage from './pages/KVKKPage';

// Korumalı route — giriş yapılmamışsa yönlendir
const PrivateRoute = ({ children, allowedRoles }) => {
  const { user, token, initialized } = useAuthStore();

  if (!token) return <Navigate to="/login" replace />;
  if (!initialized) return <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100vh', color:'#9ca3af' }}>Yükleniyor...</div>;
  if (allowedRoles && !allowedRoles.includes(user?.role)) {
    return <Navigate to="/" replace />;
  }
  return children;
};

// Giriş yapmışsa panele, yapmamışsa /home'a
const RoleRedirect = () => {
  const { user, token, initialized } = useAuthStore();
  if (!token) return <Navigate to="/home" replace />;
  if (!initialized) return <Navigate to="/home" replace />;
  if (user?.role === 'student') return <Navigate to="/student" replace />;
  if (user?.role === 'company') return <Navigate to="/company" replace />;
  if (user?.role === 'admin') return <Navigate to="/admin" replace />;
  return <Navigate to="/home" replace />;
};

const App = () => {
  const { token, fetchMe } = useAuthStore();

  useEffect(() => {
    if (token) fetchMe();
  }, [token, fetchMe]);

  return (
    <BrowserRouter>
      <Routes>
        {/* Public */}
        <Route path="/home" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/sirket-giris" element={<LoginPage />} />
        <Route path="/sirket-kayit" element={<RegisterPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/kvkk" element={<KVKKPage />} />
        <Route path="/" element={<RoleRedirect />} />

        {/* Öğrenci sayfaları */}
        <Route path="/student" element={
          <PrivateRoute allowedRoles={['student']}>
            <StudentDashboard />
          </PrivateRoute>
        }/>
        <Route path="/student/profile" element={
          <PrivateRoute allowedRoles={['student']}>
            <StudentProfile />
          </PrivateRoute>
        }/>
        <Route path="/student/applications" element={
          <PrivateRoute allowedRoles={['student']}>
            <StudentApplications />
          </PrivateRoute>
        }/>
        <Route path="/student/portfolio" element={
          <PrivateRoute allowedRoles={['student']}>
            <StudentPortfolio />
          </PrivateRoute>
        }/>
        <Route path="/student/faq" element={
          <PrivateRoute allowedRoles={['student']}>
            <StudentFAQ />
          </PrivateRoute>
        }/>
        <Route path="/student/2fa" element={
          <PrivateRoute allowedRoles={['student', 'company']}>
            <TwoFA />
          </PrivateRoute>
        }/>

        {/* Şirket sayfaları */}
        <Route path="/company" element={
          <PrivateRoute allowedRoles={['company']}>
            <CompanyDashboard />
          </PrivateRoute>
        }/>
        <Route path="/company/profile" element={
          <PrivateRoute allowedRoles={['company']}>
            <CompanyProfile />
          </PrivateRoute>
        }/>
        <Route path="/company/positions" element={
          <PrivateRoute allowedRoles={['company']}>
            <CompanyPositions />
          </PrivateRoute>
        }/>
        <Route path="/company/students" element={
          <PrivateRoute allowedRoles={['company']}>
            <CompanyStudents />
          </PrivateRoute>
        }/>
        <Route path="/company/candidates/:positionId" element={
          <PrivateRoute allowedRoles={['company']}>
            <CompanyCandidates />
          </PrivateRoute>
        }/>
        <Route path="/company/2fa" element={
          <PrivateRoute allowedRoles={['company']}>
            <TwoFA />
          </PrivateRoute>
        }/>

        {/* Admin sayfaları */}
        <Route path="/admin/*" element={
          <PrivateRoute allowedRoles={['admin']}>
            <AdminDashboard />
          </PrivateRoute>
        }/>
        <Route path="*" element={<NotFound />} />
      </Routes>
      <KVKKBanner />
    </BrowserRouter>
  );
};

export default App;
